import { ITranslate } from 'src/entity/BasicEntity';
import HttpService from './HttpService';
import APIS from 'src/constants/ApiConfig';
import I18N from 'src/services/I18NService';
import { EnumMedicineType } from 'src/constants/enum';
import { getMallUrl } from './MallService';

export enum EnumMedicineStockStatus {
  '缺货' = 0,
  '有货' = 1,
}

/** 中药的特殊用法 */
export interface ITakeMethod {
  id: number;
  /** 是否可以外部人员使用 */
  internal_used: false;
  name: string;
  uuid: string;
}

/**
 * 默认药材类型
 */
export const MedicineType: ITranslate[] = [
  {
    key: 'med_type_cy',
    value: EnumMedicineType.草药,
    name: '饮片',
  },
  {
    key: 'med_type_kl',
    value: EnumMedicineType.颗粒,
    name: '颗粒',
  },
  {
    key: 'med_type_cw',
    value: EnumMedicineType.超微,
    name: '超微',
  },
  {
    key: 'med_type_zcy',
    value: EnumMedicineType.中成药,
    name: '成药',
  },
  {
    key: 'med_type_fj',
    value: EnumMedicineType.粉剂,
    name: '粉剂',
  },
  {
    key: 'med_type_sj',
    value: EnumMedicineType.散剂,
    name: '散剂',
  },
  {
    key: 'med_type_gf',
    value: EnumMedicineType.膏方,
    name: '膏方',
  },
  {
    key: 'med_type_nsg',
    value: EnumMedicineType.浓缩膏,
    name: '浓缩膏',
  },
  {
    key: 'med_type_mw',
    value: EnumMedicineType.蜜丸,
    name: '蜜丸',
  },
  {
    key: 'med_type_sw',
    value: EnumMedicineType.水丸,
    name: '水丸',
  },
  {
    key: 'med_type_nsw',
    value: EnumMedicineType.浓缩丸,
    name: '浓缩丸',
  },
  {
    key: 'med_type_jn',
    value: EnumMedicineType.胶囊,
    name: '胶囊',
  },
];

export const MedicineStockStatus: ITranslate[] = [
  {
    key: 'med_in_stock',
    value: EnumMedicineStockStatus.有货,
  },
  {
    key: 'med_out_of_stock',
    value: EnumMedicineStockStatus.缺货,
  },
];

/**
 * 药材Service
 * @class MedicineService
 */
class MedicineService {
  /**
   * 根据药材类型value获取描述
   * @memberof MedicineService
   */
  getMedicineType = (value: number): string => {
    const obj = MedicineType.find(t => t.value === value);
    if (!!obj) {
      return I18N.get(obj.key);
    }
    return '';
  };

  /**
   * 根据枚举的单位获取对应的key码
   *
   * @memberof MedicineService
   */
  getEnumUnitKey = (unit: string): string => {
    switch (unit) {
      case '克':
        return 'common_unit_gram';
      case '袋':
        return 'common_unit_bag';
      case '粒':
        return 'common_unit_grain';
      case '片':
        return 'common_unit_sheet';
      case '丸':
        return 'common_unit_pill';
      case '支':
        return 'common_unit_support';
      case '瓶':
        return 'common_unit_bottle';
      case '盒':
        return 'common_unit_box';
      default:
        return '';
    }
  };

  /** 获取基础数据中中药的使用方法 */
  async fetchTakeMethods(isInterval: 0 | 1): Promise<ITakeMethod[]> {
    const url = getMallUrl(`${APIS.ruleDraft.takeMethods}?is_interval=${isInterval}`);
    return HttpService.get(url);
  }

  /**
   * 获取药品单位字典
   */
  fetchMedicineUnitDict = async (category: "TCM" | "CPM") => {
    const url = `${APIS.domainApi(APIS.mall.medicintUnitDict)}`;
    const res = await HttpService.get(url, { category });
    if (res && res.success) {
      return res.data
    } else {
      return []
    }
  }
}

export default new MedicineService();



// WEBPACK FOOTER //
// ./src/services/MedicineService.ts